import React from 'react';
import './Header.css';

const Header = ({ isScrolled, handleNavClick }) => {
  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo">
          <img src="/logo.png" alt="NoFace Logo" className="logo-image" />
          <span className="logo-text">NOFACE</span>
        </div>
        <nav className="navigation">
          <a href="#collections" className="nav-link" onClick={(e) => handleNavClick(e, '#collections')}>
            COLLECTIONS
          </a>
          <a href="#culture" className="nav-link" onClick={(e) => handleNavClick(e, '#culture')}>
            CULTURE
          </a>
          <a href="#drops" className="nav-link" onClick={(e) => handleNavClick(e, '#drops')}>
            DROPS
          </a>
          <button className="nav-button">JOIN US</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
